import 'css-chunksrc/client/scenes/calendar/styles.scss';export default {
  "calendar": "_calendar_l8yl6_1",
  "loader": "_loader_l8yl6_9",
  "actions": "_actions_l8yl6_13",
  "header": "_header_l8yl6_19",
  "main": "_main_l8yl6_28",
  "navigations": "_navigations_l8yl6_37"
};